import React, { useEffect, useState } from "react";
import Header from "../../component/Header";
import Sidebar from "../../component/SideBar";
import {
  Modal,
  TextField,
  Select,
  MenuItem,
  Button,
  Toolbar,
  Typography,
  FormControl,
  InputLabel,
  TablePagination,
  FormHelperText,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Navigate, useNavigate } from "react-router-dom";
import Apiconnection from "../../utils/Apiconnection";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import moment from "moment";
import { markVehicleReadyAndNotifyCustomer } from "../../service/notificationService";

const BookingList = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [actionType, setActionType] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [totalBookings, setTotalBookings] = useState(0);
  const [passengerCount, setPassengerCount] = useState(4);
  const [agentList, setAgentList] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [errors, setErrors] = useState({});

  const [openCheckInModal, setOpenCheckInModal] = useState(false);
  const [checkInForm, setCheckInForm] = useState({
    actualvehicleTypeId: "",
    actualFromDate: moment().format("YYYY-MM-DD"),
    actualCheckInTime: moment().format("HH:mm"),
    slotId: "",
    plateNumber: "",
  });

  const [openCheckOutModal, setOpenCheckOutModal] = useState(false);
  const [checkOutForm, setCheckOutForm] = useState({
    bookingRequestId: "",
    actualToDate: moment().format("YYYY-MM-DD"),
    actualCheckOutTime: moment().format("HH:mm"),
  });

  const [checkoutBookingDetails, setCheckoutBookingDetails] = useState(null);
  const [checkoutCalculateResult, setCheckoutCalculateResult] = useState(null);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [checkoutActualDate, setCheckoutActualDate] = useState(moment().format("YYYY-MM-DD"));
  const [checkoutActualTime, setCheckoutActualTime] = useState(moment().format("HH:mm:ss"));

  const formatCurrency = (val) => {
    return `$${Number(val || 0).toFixed(0)}`;
  };

  const getQrCodeUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://v2-api.primeparkusa.com";
    const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    
    let cleanPath = path;
    if (!cleanPath.startsWith("uploads/payment-methods/") && !cleanPath.startsWith("/uploads/payment-methods/")) {
      if (cleanPath.startsWith("/")) {
        cleanPath = `uploads/payment-methods${cleanPath}`;
      } else {
        cleanPath = `uploads/payment-methods/${cleanPath}`;
      }
    }
    
    if (cleanPath.startsWith("/")) {
      cleanPath = cleanPath.slice(1);
    }
    
    return `${cleanBaseUrl}/${cleanPath}`;
  };

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const navigate = useNavigate();

  const handleCheckIn = (hasReservation) => {
    if (hasReservation) {
      navigate("/customer-booking");
    } else {
      navigate("/add-booking");
    }
    setOpenModal(false);
  };

  const fetchVehicleTypes = async () => {
    try {
      const response = await Apiconnection.post("vehicle-type-list");
      if (response.data.status) {
        setVehicleTypes(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching vehicle types:", error);
      toast.error("Failed to fetch vehicle types.");
    }
  };

  useEffect(() => {
    getAgentListApi();
    fetchVehicleTypes();
  }, []);

  const fetchBookings = async (
    currentPage = page + 1,
    currentLimit = rowsPerPage,
    currentSearch = search,
    currentActionType = actionType,
    currentStartDate = startDate,
    currentEndDate = endDate,
  ) => {
    try {
      let url = `booking-request-list?page=${currentPage}&limit=${currentLimit}`;
      if (currentActionType) url += `&actionType=${currentActionType}`;
      if (currentSearch) url += `&search=${currentSearch}`;
      if (currentStartDate)
        url += `&startDate=${currentStartDate.format("YYYY-MM-DD")}`;
      if (currentEndDate)
        url += `&endDate=${currentEndDate.format("YYYY-MM-DD")}`;

      const response = await Apiconnection.post(url);
      if (response.data.status) {
        setBookings(response.data.data);
        setFilteredBookings(response.data.data);
        setTotalBookings(response.data.totalCount);
        console.log(response.data.totalCount);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      toast.error("Failed to fetch bookings.");
    }
  };

  useEffect(() => {
    fetchBookings(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleApplyFilters = () => {
    setPage(0);
    fetchBookings(1, rowsPerPage, search, actionType, startDate, endDate);
  };

  const handleClearFilters = () => {
    setSearch("");
    setActionType("");
    setStartDate(null);
    setEndDate(null);
    setPage(0);
    fetchBookings(1, rowsPerPage, "", "", null, null);
  };

  const shouldDisableDate = (date) => {
    return date.isAfter(moment());
  };

  // Function to disable future times
  const shouldDisableTime = (time) => {
    const currentTime = moment();
    return time.isAfter(currentTime);
  };

  // useEffect(() => {
  //     const getBookings = async () => {
  //         try {
  //             const response = await Apiconnection.post('booking-request-list');
  //             if (response && response.data) {
  //                 setBookings(response.data.data);
  //             } else {
  //                 console.error('Error fetching bookings:', response.data.message);
  //             }
  //         } catch (error) {
  //             console.error('Error fetching bookings:', error);
  //         }
  //     };
  //     getBookings();
  // }, []);

  // const filteredBookings = bookings.filter(booking =>
  //     booking.bookingTicketNo.includes(search) ||
  //     booking.customerMobile.toString().includes(search) ||
  //     booking.plateNumber.includes(search)
  // );

  // const paginatedBookings = filteredBookings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const totalPages = Math.ceil(totalBookings / rowsPerPage);
  console.log("totalPages", totalPages);

  const paginatedBookings = filteredBookings.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const handleViewInvoice = async (id, tid) => {
    console.log(id, tid);
    navigate("/booking-receipts", { state: { id, tid } });

    // try {
    //     const response = await Apiconnection.post('invoice-detail', { "bookingRequestId": id });
    //     console.log('invoice-detail', response)
    // } catch (error) {
    //     console.error('Error fetching Invoice details:', error);
    // }
  };

  const handleUpdateCheckIn = async (id) => {
    try {
      const response = await Apiconnection.post("booking-request-detail", {
        bookingRequestId: id,
      });
      if (response.data.status) {
        const bookingDetails = response.data.data;
        navigate("/add-booking", { state: bookingDetails });

        // const defaultVehicleTypeId = vehicleTypes.find(type => type.typeName === "Sedan")?.id;
        // setCheckInForm({
        //     bookingRequestId: bookingDetails?.id,
        //     // actualvehicleTypeId: bookingDetails.actualvehicleTypeId,
        //     actualvehicleTypeId: defaultVehicleTypeId || "",
        //     // actualFromDate: bookingDetails.actualFromDate,
        //     // actualCheckInTime: bookingDetails.actualCheckInTime,
        //     actualFromDate: moment().format('YYYY-MM-DD'),

        //     actualCheckInTime: moment().format('HH:mm'),
        //     slotId: bookingDetails.slotId,
        //     slotName: bookingDetails.slot.slotName,
        //     plateNumber: bookingDetails.plateNumber
        // });
        // setOpenCheckInModal(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching booking details:", error);
      toast.error("Failed to fetch booking details.");
    }
  };

  const handleCheckInFormSubmit = async (event) => {
    event.preventDefault();
    if (!window.confirm("Are you sure want to change status ?")) {
      return;
    }
    try {
      const payload = {
        bookingRequestId: checkInForm.bookingRequestId,
        actualvehicleTypeId: checkInForm.actualvehicleTypeId,
        actualFromDate: checkInForm.actualFromDate,
        actualCheckInTime: checkInForm.actualCheckInTime,
        slotId: checkInForm.slotId,
        plateNumber: checkInForm.plateNumber,
        passengerCount: passengerCount,
      };
      const response = await Apiconnection.post("mark-check-in", payload);
      if (response.data.status) {
        const updatedBookings = bookings.map((booking) => {
          if (booking.id === payload.bookingRequestId) {
            return { ...booking, bookingStatus: "Checked In" };
          }
          return booking;
        });
        setBookings(updatedBookings);
        toast.success("Check-in successful!");

        const calculateChargesPayload = {
          bookingRequestId: response.data.data.updatedBookingRequest.id,
          vehicleTypeId:
            response.data.data.updatedCarMovement.actualvehicleTypeId,
          passengerCount: passengerCount,
          checkinDate: response.data.data.updatedCarMovement.actualFromDate,
          startTime: response.data.data.updatedCarMovement.actualCheckInTime,
          checkoutDate: response.data.data.updatedBookingRequest.toDate,
          endTime:
            response.data.data.updatedBookingRequest.selectedCheckOutTime,
        };
        console.log("calculateChargesPayload", calculateChargesPayload);

        const calculateChargesResponse = await Apiconnection.post(
          "calculate-booking-charges-after-check-in",
          calculateChargesPayload,
        );
        if (calculateChargesResponse.data.status) {
          console.log(
            "Booking charges calculated successfully:",
            calculateChargesResponse.data,
          );
        } else {
          toast.error(calculateChargesResponse.data.message);
        }

        setOpenCheckInModal(false);
        fetchBookings();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating check-in:", error);
      toast.error("Failed to update check-in.");
    }
  };

  const handleUpdateCheckOut = async (id) => {
    setLoadingCheckout(true);
    try {
      // Step 1: Call booking-request-detail
      const detailResponse = await Apiconnection.post("booking-request-detail", {
        bookingRequestId: id,
      });
      if (!detailResponse.data.status) {
        toast.error(detailResponse.data.message || "Failed to fetch booking details.");
        setLoadingCheckout(false);
        return;
      }
      
      const bookingDetails = detailResponse.data.data;
      const bId = bookingDetails.id || bookingDetails.bookingRequestId || id;
      const endTimeVal = bookingDetails.endTime || bookingDetails.selectedCheckOutTime;
      const todayDate = moment().format("YYYY-MM-DD");
      
      // Step 2: Call calculate-booking-charges-after-check-out
      const calculatePayload = {
        bookingRequestId: bId,
        platformMedium: "AdminBooking",
        checkoutDate: todayDate,
        endTime: endTimeVal || moment().format("HH:mm:ss"),
      };
      
      const calculateResponse = await Apiconnection.post(
        "calculate-booking-charges-after-check-out",
        calculatePayload
      );
      
      if (!calculateResponse.data.status) {
        toast.error(calculateResponse.data.message || "Failed to calculate booking charges.");
        setLoadingCheckout(false);
        return;
      }
      
      const calcResult = calculateResponse.data.data || calculateResponse.data;
      
      // Fetch payment list if payment is required
      if (calcResult.requiresPayment) {
        try {
          const pmResponse = await Apiconnection.post("payment-method-list");
          if (pmResponse?.data?.status) {
            const list = pmResponse.data.data?.paymentMethodList || pmResponse.data.data || [];
            const mapped = list.map((item) => {
              const qrRequired = item.isQrRequired === true || item.isQrRequired === 1 || item.isQrRequired === "true";
              return {
                value: item.methodName,
                label: item.methodName,
                enabled: true,
                description: item.methodName === "Cash" ? "Collect payment in person" : `Use ${item.methodName} for this checkout`,
                isQrRequired: qrRequired,
                qrCode: item.qrCode,
                id: item.paymentMethodId || item.id,
              };
            });
            setPaymentMethodOptions(mapped);
            if (mapped.length > 0) {
              const cashMethod = mapped.find(m => m.value.toLowerCase() === "cash");
              setSelectedPaymentMethod(cashMethod ? cashMethod.value : mapped[0].value);
            }
          }
        } catch (pmError) {
          console.error("Error fetching payment methods:", pmError);
        }
      }
      
      setCheckoutBookingDetails(bookingDetails);
      setCheckoutCalculateResult(calcResult);
      setCheckoutActualDate(todayDate);
      setCheckoutActualTime(moment().format("HH:mm:ss"));
      setOpenCheckOutModal(true);
    } catch (error) {
      console.error("Error during checkout initialization:", error);
      toast.error("Failed to initialize checkout.");
    } finally {
      setLoadingCheckout(false);
    }
  };

  const handleCheckOutSubmit = async () => {
    if (!checkoutBookingDetails || !checkoutCalculateResult) return;
    
    const getField = (obj, field) => {
      if (!obj) return undefined;
      if (obj[field] !== undefined) return obj[field];
      if (obj.chargesSummary && obj.chargesSummary[field] !== undefined) return obj.chargesSummary[field];
      if (obj.invoiceCreate && obj.invoiceCreate[field] !== undefined) return obj.invoiceCreate[field];
      if (obj.bookingChargesSummary && obj.bookingChargesSummary[field] !== undefined) return obj.bookingChargesSummary[field];
      if (obj.bookingChargesDetail && obj.bookingChargesDetail[field] !== undefined) return obj.bookingChargesDetail[field];
      if (obj.data && obj.data[field] !== undefined) return obj.data[field];
      return undefined;
    };

    const bId = checkoutBookingDetails.id || checkoutBookingDetails.bookingRequestId;
    const requiresPayment = getField(checkoutCalculateResult, "requiresPayment") === true || checkoutCalculateResult.requiresPayment === true;
    
    setLoadingCheckout(true);
    try {
      const markPayload = {
        bookingRequestId: bId,
        actionType: "CheckOut",
        actualToDate: checkoutActualDate,
        actualCheckOutTime: checkoutActualTime,
        platformMedium: "AdminBooking",
      };

      if (requiresPayment) {
        if (!selectedPaymentMethod) {
          toast.error("Please select a payment method.");
          setLoadingCheckout(false);
          return;
        }
        
        // 1. Attempt checkout -> writes overstay/due, returns 402 or failure if unpaid
        try {
          await Apiconnection.post("mark-check-out", markPayload);
        } catch (markError) {
          console.log("Expected mark-check-out temporary response/error:", markError);
        }
        
        // 2. Pay the now-persisted due
        const payPayload = {
          bookingRequestId: bId,
          paymentMethod: selectedPaymentMethod,
        };
        const payResponse = await Apiconnection.post("pay-overstay", payPayload);
        if (!payResponse.data.status) {
          toast.error(payResponse.data.message || "Payment failed.");
          setLoadingCheckout(false);
          return;
        }
      }
      
      // 3. Checkout (again if paid, or first time if requiresPayment is false) -> due is 0, succeeds
      const markResponse = await Apiconnection.post("mark-check-out", markPayload);
      if (markResponse.data.status) {
        // Update local state booking status
        const updatedBookings = bookings.map((booking) => {
          if (booking.id === bId) {
            return { ...booking, bookingStatus: "Checked Out" };
          }
          return booking;
        });
        setBookings(updatedBookings);
        setFilteredBookings(updatedBookings);
        toast.success("Check-out successful!");
        setOpenCheckOutModal(false);
        fetchBookings();

        // Redirect to receipt page
        navigate("/booking-receipts", {
          state: {
            id: bId,
            tid: markResponse.data.data?.updatedBookingRequest?.transactionHistoryId || null,
          },
        });
      } else {
        toast.error(markResponse.data.message || "Checkout failed.");
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      toast.error("Failed to complete checkout.");
    } finally {
      setLoadingCheckout(false);
    }
  };

  const getAgentListApi = async () => {
    try {
      const response = await Apiconnection.post("agent-list");
      console.log("agent-list", response);
      if (response?.data?.status) {
        setAgentList(response.data.data.agentList);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching Agent list:", error);
      toast.error("Failed to fetch Agent list.");
    } finally {
    }
  };

  const handleStatusChange = (event, id) => {
    const updatedBookings = bookings.map((booking) => {
      if (booking.id === id) {
        return { ...booking, bookingStatus: event.target.value };
      }
      return booking;
    });
    setBookings(updatedBookings);
  };

  const handleAssignStatusChange = async (event, id) => {
    try {
      const payload = {
        agentId: event.target.value,
        bookingRequestId: id,
      };

      const response = await Apiconnection.post(
        "assign-agent-to-booking-request",
        payload,
      );

      if (response.data.status) {
        const updatedBookings = bookings.map((booking) => {
          if (booking.id === id) {
            return { ...booking, bookingStatus: event.target.value };
          }
          return booking;
        });
        setBookings(updatedBookings);
        toast.success("Agent assigned successfully!");
        fetchBookings(page + 1, rowsPerPage);
      } else {
        toast.error(response.data.message || "Failed to assign agent.");
      }
    } catch (error) {
      console.error("Error assigning agent:", error);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateStatus = (event, id) => {
    const updatedBookings = bookings.map((booking) => {
      if (booking.id === id) {
        return { ...booking, paymentStatus: event.target.value };
      }
      return booking;
    });
    setBookings(updatedBookings);
  };

  const handleActionChanges = async (id) => {
    if (!window.confirm("Are you sure want to change status ?")) {
      return;
    }
    const token = localStorage.getItem("prime_access_token");

    try {
      const { readyResponse, notificationResponse } =
        await markVehicleReadyAndNotifyCustomer({
          bookingRequestId: id,
          token,
        });

      if (readyResponse.data.status && notificationResponse.data.status) {
        const updatedBookings = bookings.map((booking) => {
          if (booking.id === id) {
            return { ...booking, readyStatus: "Ready" };
          }
          return booking;
        });
        setBookings(updatedBookings);
        toast.success(
          notificationResponse.data.message ||
            readyResponse.data.message ||
            "Vehicle marked ready successfully!",
        );
        fetchBookings();
      } else {
        toast.error(
          notificationResponse.data.message ||
            readyResponse.data.message ||
            "Failed to mark vehicle ready.",
        );
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(
        error?.response?.data?.message || "Failed to mark vehicle ready.",
      );
    }
  };

  const handleActionChange = (event, id) => {
    const updatedBookings = bookings.map((booking) => {
      if (booking.id === id) {
        return { ...booking, paymentStatus: event.target.value };
      }
      return booking;
    });
    setBookings(updatedBookings);
  };

  // Sample data
  const rows = [
    {
      ticketId: "T001",
      customerDetails: "John Doe",
      lotSlot: "Lot A, Slot 1",
      resvId: "R001",
      pickupDateTime: "2024-09-01 10:00 AM",
      assignedTo: "Agent A",
      status: "Pending",
    },
    {
      ticketId: "T002",
      customerDetails: "Jane Smith",
      lotSlot: "Lot B, Slot 2",
      resvId: "R002",
      pickupDateTime: "2024-09-02 11:00 AM",
      assignedTo: "Agent B",
      status: "Completed",
    },
    {
      ticketId: "T001",
      customerDetails: "John Doe",
      lotSlot: "Lot A, Slot 1",
      resvId: "R001",
      pickupDateTime: "2024-09-01 10:00 AM",
      assignedTo: "Agent A",
      status: "Pending",
    },
    {
      ticketId: "T002",
      customerDetails: "Jane Smith",
      lotSlot: "Lot B, Slot 2",
      resvId: "R002",
      pickupDateTime: "2024-09-02 11:00 AM",
      assignedTo: "Agent B",
      status: "Completed",
    },
    {
      ticketId: "T001",
      customerDetails: "John Doe",
      lotSlot: "Lot A, Slot 1",
      resvId: "R001",
      pickupDateTime: "2024-09-01 10:00 AM",
      assignedTo: "Agent A",
      status: "Pending",
    },
    {
      ticketId: "T002",
      customerDetails: "Jane Smith",
      lotSlot: "Lot B, Slot 2",
      resvId: "R002",
      pickupDateTime: "2024-09-02 11:00 AM",
      assignedTo: "Agent B",
      status: "Completed",
    },
    // Add more sample rows as needed
  ];

  const filteredRows = rows.filter(
    (row) =>
      row?.ticketId?.includes(search) ||
      row?.customerDetails?.toLowerCase()?.includes(search.toLowerCase()),
  );

  const rowsPerPageOptions = [5, 10, 15, 20, 25, totalBookings];

  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  // const paginatedBookings = bookings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <div className="grid-container">
      <Header OpenSidebar={OpenSidebar} />
      <Sidebar
        openSidebarToggle={openSidebarToggle}
        OpenSidebar={OpenSidebar}
      />
      <div className="inner-container">
        <div className="custom-table">
          <Toolbar
            sx={{ flexWrap: "wrap", gap: 2, paddingY: 2, paddingInline: 0 }}
          >
            <Typography variant="h6" style={{ flex: 1, minWidth: "150px" }}>
              Booking List
            </Typography>
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ minWidth: "150px" }}
            />
            <FormControl
              variant="outlined"
              size="small"
              style={{ minWidth: "150px" }}
            >
              <InputLabel>Action Type</InputLabel>
              <Select
                value={actionType}
                onChange={(e) => setActionType(e.target.value)}
                label="Action Type"
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                <MenuItem value="CheckIn">CheckIn</MenuItem>
                <MenuItem value="CheckOut">CheckOut</MenuItem>
              </Select>
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                format="YYYY-MM-DD"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    style={{ width: "150px" }}
                  />
                )}
              />
              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                format="YYYY-MM-DD"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    style={{ width: "150px" }}
                  />
                )}
              />
            </LocalizationProvider>
            <Button
              variant="contained"
              color="primary"
              onClick={handleApplyFilters}
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClearFilters}
            >
              Clear
            </Button>

            <Button
              variant="contained"
              className="action-btn"
              onClick={handleOpenModal}
            >
              <AddIcon /> CHECK IN
            </Button>
            <Modal
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="add-user-modal"
              aria-describedby="add-user-modal-description"
            >
              <div
                className="booking-modal"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  padding: "0px",
                  border: "1px solid gray",
                  borderRadius: "5px",
                }}
              >
                <h2 id="modal-title">Check In</h2>
                <h6>Does the Customer have a reservation?</h6>
                <div id="modal-description">
                  <Button
                    variant="contained"
                    className="yes-btn"
                    color="primary"
                    onClick={() => handleCheckIn(true)}
                  >
                    Yes
                  </Button>
                  <Button
                    variant="contained"
                    className="no-btn"
                    color="secondary"
                    onClick={() => handleCheckIn(false)}
                  >
                    No
                  </Button>
                </div>
              </div>
            </Modal>
          </Toolbar>
        </div>

        <div
          className="custom-table table-responsive booking-table-wrap"
          style={{ marginTop: "20px" }}
        >
          <table className="table booking-data-table">
            <thead>
              <tr>
                <th>Ticket ID</th>
                <th>Customer Details</th>
                <th>Slot</th>
                <th>Schedule Date & Time</th>
                <th>Assigned To</th>
                <th>Status</th>
                <th>Action</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {filteredBookings.length > 0 ? (
                filteredBookings.map((booking) => (
                  <tr key={booking.id}>
                    <td>{booking.bookingTicketNo}</td>
                    <td>
                      <div className="booking-customer-cell">
                        <div className="booking-customer-avatar">
                          {(
                            (booking.user?.firstName?.charAt(0) || "") +
                            (booking.user?.lastName?.charAt(0) || "")
                          ).toUpperCase()}
                        </div>
                        <span className="booking-customer-meta">
                          {booking.user?.firstName || ""}{" "}
                          {booking.user?.lastName || ""}
                          <br />
                          {booking.customerMobile}
                        </span>
                      </div>
                    </td>
                    <td>{booking.slot?.slotName || "N/A"}</td>
                    <td>
                      <div className="booking-schedule-cell">
                        <div>
                          {moment(booking.fromDate).format("DD-MM-YYYY")} |{" "}
                          {booking.selectedCheckInTime}
                        </div>
                        <div className="booking-schedule-separator">To</div>
                        <div>
                          {moment(booking.toDate).format("DD-MM-YYYY")} |{" "}
                          {booking.selectedCheckOutTime}
                        </div>
                      </div>
                    </td>
                    <td>
                      <FormControl variant="standard" sx={{ width: 120 }}>
                        <Select
                          value={
                            booking.agentbookingmapping
                              ? booking.agentbookingmapping.agentId
                              : ""
                          }
                          disabled={booking.bookingStatus === "Checked Out"}
                          sx={{
                            borderRadius: 2,
                            border: "1px solid #ccc",
                            padding: "5px 10px",
                            fontSize: 14,
                            color: "#333", // Ensure text is visible
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #ccc",
                              "&:hover": {
                                border: "1px solid #ccc",
                              },
                              "&.Mui-focused": {
                                border: "1px solid #ccc",
                                boxShadow: "none",
                              },
                            },
                          }}
                          onChange={(event) =>
                            handleAssignStatusChange(event, booking.id)
                          }
                          MenuProps={{
                            PaperProps: {
                              style: {
                                position: "absolute",
                                top: "auto",
                                left: "auto",
                                right: "auto",
                                transform: "translateY(0)",
                              },
                            },
                          }}
                          renderValue={(selected) => {
                            return selected === "" ? (
                              <em>Select Agent</em>
                            ) : (
                              agentList.find((item) => item.id === selected)
                                ?.user.firstName +
                                " " +
                                agentList.find((item) => item.id === selected)
                                  ?.user.lastName
                            );
                          }}
                        >
                          <MenuItem value="">
                            <em>Select Agent</em>
                          </MenuItem>
                          {agentList.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.user.firstName} {item.user.lastName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>

                    <td>
                      <Button
                        variant="contained"
                        color={
                          booking.readyStatus === "Ready"
                            ? "secondary"
                            : "primary"
                        }
                        onClick={() => handleActionChanges(booking.id)}
                        disabled={
                          booking.readyStatus === "Not Requested" ||
                          booking.readyStatus === "Ready"
                        }
                      >
                        {booking.readyStatus === "Requested"
                          ? "Ready"
                          : "Ready"}
                      </Button>
                    </td>

                    <td>
                      <div>
                        {booking.bookingStatus === "Booked" ? (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleUpdateCheckIn(booking.id)}
                            sx={{ fontSize: 12 }}
                          >
                            Check In
                          </Button>
                        ) : booking.bookingStatus === "Checked In" ? (
                          <Button
                            variant="contained"
                            color={
                              booking.toDate &&
                              moment().isAfter(
                                moment(
                                  `${moment(booking.toDate).format("YYYY-MM-DD")}T${booking.selectedCheckOutTime || "00:00"}`
                                )
                              )
                                ? "error"
                                : "secondary"
                            }
                            onClick={() => handleUpdateCheckOut(booking.id)}
                            sx={{ fontSize: 12 }}
                          >
                            Check Out
                          </Button>
                        ) : booking.bookingStatus === "Checked Out" ? (
                          <Button
                            variant="contained"
                            color="secondary"
                            disabled
                            sx={{ fontSize: 12 }}
                          >
                            Checked Out
                          </Button>
                        ) : booking.bookingStatus === "Failed" ? (
                          <Button
                            variant="contained"
                            color="error"
                            disabled
                            sx={{ fontSize: 12 }}
                          >
                            Failed
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleUpdateCheckIn(booking.id)}
                            sx={{ fontSize: 12 }}
                          >
                            Check In
                          </Button>
                        )}
                      </div>
                    </td>
                    <td>
                      <i
                        className="fas fa-eye"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleViewInvoice(
                            booking.id,
                            booking.transactionHistoryId,
                          )
                        }
                      ></i>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center empty-table-cell">
                    No bookings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 20, 25, totalBookings]}
          component="div"
          count={totalBookings}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          nextButtonProps={{
            disabled:
              page >= Math.ceil(filteredBookings.length / rowsPerPage) - 1,
          }}
          backButtonProps={{ disabled: page === 0 }}
        />
        <Modal
          open={openCheckInModal}
          onClose={() => setOpenCheckInModal(false)}
          aria-labelledby="check-in-modal"
          aria-describedby="check-in-modal-description"
        >
          <div
            className="check-in-modal"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "20px",
              border: "1px solid gray",
              borderRadius: "5px",
            }}
          >
            <IconButton
              onClick={() => setOpenCheckInModal(false)}
              style={{ position: "absolute", top: "10px", right: "10px" }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <h2 id="check-in-modal-title" className="mb-4">
              Check In
            </h2>
            <form onSubmit={handleCheckInFormSubmit}>
              <FormControl fullWidth error={errors?.actualvehicleTypeId}>
                <InputLabel id="actualvehicleTypeId-label">
                  Vehicle Type
                </InputLabel>
                <Select
                  labelId="actualvehicleTypeId-label"
                  id="actualvehicleTypeId"
                  value={checkInForm.actualvehicleTypeId}
                  onChange={(event) =>
                    setCheckInForm({
                      ...checkInForm,
                      actualvehicleTypeId: event.target.value,
                    })
                  }
                >
                  {vehicleTypes.map((vehicleType) => (
                    <MenuItem value={vehicleType.id}>
                      {vehicleType.typeName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors?.actualvehicleTypeId}</FormHelperText>
              </FormControl>

              <TextField
                label="Number of Passengers"
                type="number"
                variant="outlined"
                size="small"
                value={passengerCount}
                onChange={(event) => {
                  const value = Math.max(1, Math.min(20, event.target.value)); // Clamp value between 1 and 20
                  setPassengerCount(value);
                }}
                inputProps={{ min: 1, max: 20 }}
                style={{ marginBottom: "10px" }}
              />

              <div className="d-flex cus-gap">
                <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Check In Date"
                    disabled
                    value={
                      checkInForm.actualFromDate
                        ? moment(checkInForm.actualFromDate)
                        : null
                    }
                    onChange={(newValue) => {
                      setCheckInForm({
                        ...checkInForm,
                        actualFromDate: newValue.format("YYYY-MM-DD"),
                      });
                    }}
                    shouldDisableDate={shouldDisableDate}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Check In Time"
                    disabled
                    value={
                      checkInForm.actualCheckInTime
                        ? moment(checkInForm.actualCheckInTime, "HH:mm")
                        : null
                    }
                    onChange={(newValue) => {
                      setCheckInForm({
                        ...checkInForm,
                        actualCheckInTime: newValue.format("HH:mm"),
                      });
                    }}
                    shouldDisableTime={shouldDisableTime}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </div>

              <TextField
                label="Slot Name"
                variant="outlined"
                size="small"
                value={checkInForm.slotName}
                onChange={(event) =>
                  setCheckInForm({ ...checkInForm, slotId: event.target.value })
                }
                style={{ marginBottom: "10px" }}
              />
              <TextField
                label="Plate Number"
                variant="outlined"
                size="small"
                value={checkInForm.plateNumber}
                onChange={(event) =>
                  setCheckInForm({
                    ...checkInForm,
                    plateNumber: event.target.value,
                  })
                }
                style={{ marginBottom: "10px" }}
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginTop: "10px", float: "right" }}
              >
                Edit
              </Button>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginTop: "10px", float: "right" }}
              >
                Submit
              </Button>
            </form>
          </div>
        </Modal>

        <Modal
          open={openCheckOutModal}
          onClose={() => setOpenCheckOutModal(false)}
          aria-labelledby="check-out-modal"
          aria-describedby="check-out-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#1E1E1E",
              padding: "24px",
              borderRadius: "16px",
              width: "min(520px, 95vw)",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
              color: "#ffffff",
              fontFamily: "'Inter', 'Outfit', sans-serif",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#ffffff" }}>
                Check out
              </h2>
              <IconButton
                onClick={() => setOpenCheckOutModal(false)}
                style={{ color: "#888888", padding: "4px" }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>

            {/* Inputs: Actual checkout date and actual checkout time */}
            <div style={{ display: "flex", gap: "16px", marginBottom: "20px" }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: "block", color: "#aaaaaa", fontSize: "12px", marginBottom: "6px" }}>
                  Actual check out date
                </label>
                <div
                  style={{
                    backgroundColor: "#2c2c2c",
                    border: "1px solid #3c3c3c",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    color: "#ffffff",
                    fontSize: "15px",
                  }}
                >
                  {checkoutActualDate ? moment(checkoutActualDate).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY")}
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: "block", color: "#aaaaaa", fontSize: "12px", marginBottom: "6px" }}>
                  Actual check out time
                </label>
                <div
                  style={{
                    backgroundColor: "#2c2c2c",
                    border: "1px solid #3c3c3c",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    color: "#ffffff",
                    fontSize: "15px",
                  }}
                >
                  {checkoutActualTime ? moment(checkoutActualTime, "HH:mm:ss").format("hh:mm A") : moment().format("hh:mm A")}
                </div>
              </div>
            </div>

            {/* Alert banner */}
            {checkoutCalculateResult && (() => {
              const getField = (obj, field) => {
                if (!obj) return undefined;
                if (obj[field] !== undefined) return obj[field];
                if (obj.chargesSummary && obj.chargesSummary[field] !== undefined) return obj.chargesSummary[field];
                if (obj.invoiceCreate && obj.invoiceCreate[field] !== undefined) return obj.invoiceCreate[field];
                if (obj.bookingChargesSummary && obj.bookingChargesSummary[field] !== undefined) return obj.bookingChargesSummary[field];
                if (obj.bookingChargesDetail && obj.bookingChargesDetail[field] !== undefined) return obj.bookingChargesDetail[field];
                if (obj.data && obj.data[field] !== undefined) return obj.data[field];
                return undefined;
              };

              const requiresPayment = getField(checkoutCalculateResult, "requiresPayment") === true || checkoutCalculateResult.requiresPayment === true;
              const overstayDays = Number(getField(checkoutCalculateResult, "overstayDays") || 0);
              const overstayAmountTotal = Number(getField(checkoutCalculateResult, "overstayAmountTotal") || getField(checkoutCalculateResult, "overstayAmount") || 0);
              const paidAmount = Number(getField(checkoutCalculateResult, "paidAmount") || getField(checkoutCalculateResult, "alreadyPaid") || 0);
              const dueAmount = Number(getField(checkoutCalculateResult, "dueAmount") || 0);
              const overstayRate = overstayDays > 0 ? (overstayAmountTotal / overstayDays) : 0;

              console.log("checkoutCalculateResult",checkoutCalculateResult);

              return (
                <>
                  {requiresPayment ? (
                    <div
                      style={{
                        backgroundColor: "#3A220F",
                        borderRadius: "8px",
                        color: "#F29C38",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        marginBottom: "20px",
                        lineHeight: "1.4",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "10px", flexShrink: 0 }}
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      <span>
                        {overstayDays} days overstay. Extra payment required.
                      </span>
                    </div>
                  ) : (
                    <div
                      style={{
                        backgroundColor: "#0F2F16",
                        borderRadius: "8px",
                        color: "#4ade80",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        marginBottom: "20px",
                        lineHeight: "1.4",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "10px", flexShrink: 0 }}
                      >
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                      <span>On time. Nothing extra to pay.</span>
                    </div>
                  )}

                  {/* Calculation breakdown card */}
                  {requiresPayment && (
                    <div
                      style={{
                        backgroundColor: "#262626",
                        border: "1px solid #333333",
                        borderRadius: "12px",
                        padding: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", fontSize: "14px" }}>
                        <span style={{ color: "#999999" }}>Already paid</span>
                        <span style={{ color: "#ffffff", fontWeight: "500" }}>
                          {formatCurrency(paidAmount)}
                        </span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", fontSize: "14px" }}>
                        <span style={{ color: "#999999" }}>
                          Overstay ({overstayDays} days × {formatCurrency(overstayRate)})
                        </span>
                        <span style={{ color: "#ffffff", fontWeight: "500" }}>
                          {formatCurrency(overstayAmountTotal)}
                        </span>
                      </div>
                      <hr style={{ border: "none", borderTop: "1px solid #3d3d3d", margin: "12px 0" }} />
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "15px", fontWeight: "bold" }}>
                        <span style={{ color: "#ffffff" }}>Extra to pay</span>
                        <span style={{ color: "#F87171" }}>
                          {formatCurrency(dueAmount)}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Payment Method section */}
                  {requiresPayment && (
                    <div style={{ marginBottom: "20px" }}>
                      <label style={{ display: "block", color: "#aaaaaa", fontSize: "13px", marginBottom: "10px" }}>
                        Payment method
                      </label>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                        {paymentMethodOptions.map((method) => {
                          const isSelected = selectedPaymentMethod === method.value;
                          return (
                            <button
                              key={method.value}
                              type="button"
                              onClick={() => setSelectedPaymentMethod(method.value)}
                              style={{
                                backgroundColor: "#262626",
                                border: isSelected ? "2px solid #1D70E2" : "1px solid #3c3c3c",
                                borderRadius: "24px",
                                padding: "8px 20px",
                                color: "#ffffff",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: isSelected ? "600" : "normal",
                                transition: "all 0.2s ease",
                                outline: "none",
                              }}
                            >
                              {method.label}
                            </button>
                          );
                        })}
                      </div>

                      {/* QR Code details */}
                      {(() => {
                        const activeMethodObj = paymentMethodOptions.find(m => m.value === selectedPaymentMethod);
                        if (activeMethodObj && activeMethodObj.isQrRequired && activeMethodObj.qrCode) {
                          return (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "16px", gap: "8px", padding: "12px", backgroundColor: "#262626", borderRadius: "12px", border: "1px solid #333333" }}>
                              <span style={{ color: "#aaaaaa", fontSize: "13px", fontWeight: "500" }}>
                                Scan QR to pay
                              </span>
                              <img
                                src={getQrCodeUrl(activeMethodObj.qrCode)}
                                alt={`${activeMethodObj.label} QR Code`}
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  objectFit: "contain",
                                  borderRadius: "8px",
                                  backgroundColor: "#ffffff",
                                  padding: "6px",
                                  border: "1px solid #444444"
                                }}
                              />
                              <span style={{ color: "#888888", fontSize: "12px", textAlign: "center" }}>
                                {activeMethodObj.description}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  )}

                  {/* Action button */}
                  <button
                    type="button"
                    disabled={loadingCheckout}
                    onClick={() => handleCheckOutSubmit()}
                    style={{
                      width: "100%",
                      backgroundColor: "#1D70E2",
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px",
                      fontSize: "15px",
                      fontWeight: "bold",
                      cursor: loadingCheckout ? "not-allowed" : "pointer",
                      opacity: loadingCheckout ? 0.7 : 1,
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseEnter={(e) => { if (!loadingCheckout) e.currentTarget.style.backgroundColor = "#1A62C7"; }}
                    onMouseLeave={(e) => { if (!loadingCheckout) e.currentTarget.style.backgroundColor = "#1D70E2"; }}
                  >
                    {loadingCheckout ? "Processing..." : (requiresPayment ? `Pay ${formatCurrency(dueAmount)} and check out` : "Check out")}
                  </button>
                </>
              );
            })()}
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default BookingList;
